import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetailsBaseComponent } from '../../../../../core/base/components/details-base/details-base.component';
import { SupplierService } from '../supplier.service';
import { SupplierModel } from '../../../../../core/models/supplier.model';
import { AuthService } from '../../../../../core/services/auth.service';
import { SupplierContactService } from '../supplier-contact.service';
import { SupplierApiTesterService } from '../supplier-api-tester.service';
import { HttpClient } from '@angular/common/http';
import { ENUM_PERMISSIONS } from '../../../../../core/enums/permission.enum';
import {
  ELECTRONIC_INVOICE_ICON,
  ELECTRONIC_INVOICE_ICON_COLOR,
  ELECTRONIC_INVOICE_LEGEND_LABEL,
} from '../supplier.constants';

// @ts-ignore
// @ts-ignore
@Component({
  selector: 'vex-supplier-details',
  templateUrl: './supplier-details.component.html',
  styleUrls: ['./supplier-details.component.scss'],
})
export class SupplierDetailsComponent extends DetailsBaseComponent<SupplierModel> implements OnInit {
  supplierId: string;
  missingContactsWarnings: string[] = [];
  showMissingContactsBanner = false;
  readonly ELECTRONIC_INVOICE_ICON = ELECTRONIC_INVOICE_ICON;
  readonly ELECTRONIC_INVOICE_ICON_COLOR = ELECTRONIC_INVOICE_ICON_COLOR;
  readonly ELECTRONIC_INVOICE_LEGEND_LABEL = ELECTRONIC_INVOICE_LEGEND_LABEL;
  private isInternSupplier = false;

  defaultTabs = [
    {
      label: 'INFORMATIONS',
      route: './',
      routerLinkActiveOptions: { exact: true },
      permission: ENUM_PERMISSIONS.READ_SUPPLIER_INFORMATION,
      index: 1,
    },
    {
      label: 'CONTACTS FOURNISSEURS',
      route: './contact',
      permission: ENUM_PERMISSIONS.READ_SUPPLIER_CONTACT,
      index: 2,
    },
    {
      label: 'N° CLIENT',
      route: './client-number',
      permission: ENUM_PERMISSIONS.READ_SUPPLIER_CLIENT_NUMBER,
      index: 3,
    },
    {
      label: 'DOCUMENTS',
      route: './document',
      permission: ENUM_PERMISSIONS.READ_SUPPLIER_GED,
      index: 4,
    },
    {
      label: 'API',
      route: './api',
      index: 5,
      permission: ENUM_PERMISSIONS.READ_SUPPLIER_API,
    },
    {
      label: 'TEST API',
      route: './api-test',
      index: 6,
      additionalCondition: this.supplierApiTesterService.isAvailable(),
    },
  ];

  constructor(
    public service: SupplierService,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private route: ActivatedRoute,
    public http: HttpClient,
    public supplierContactService: SupplierContactService,
    private supplierApiTesterService: SupplierApiTesterService,
  ) {
    super(service, activatedRoute, authService);
  }

  ngOnInit() {
    super.ngOnInit();

    // get the supplier id;
    this.activatedRoute.params.subscribe(params => {
      this.supplierId = params['id'];
    });

    this.service.entity$.subscribe(entity => {
      if (!entity) return;
      this.supplierId = entity._id ?? this.supplierId;
      this.isInternSupplier = !!entity.supportEstablishment;
      if (this.isInternSupplier) {
        this.showMissingContactsBanner = false;
        this.missingContactsWarnings = [];
        return;
      }
      this.loadMissingContacts();
    });
    this.service.missingContactsRefresh$.subscribe(() => {
      if (this.isInternSupplier) return;
      this.loadMissingContacts();
    });
  }

  private loadMissingContacts(): void {
    if (!this.supplierId) return;
    this.service.getEstablishmentsMissingContacts(this.supplierId).subscribe(res => {
      if (res.data?.length > 0) {
        this.showMissingContactsBanner = true;
        this.missingContactsWarnings = res.data.map(
          item => `${item.establishmentLabel} : ${item.missingContactTypes.join(', ')}`,
        );
      } else {
        this.showMissingContactsBanner = false;
        this.missingContactsWarnings = [];
      }
    });
  }
}
